import {
  CREATE_SOLAR_SITE_OPTION,
  DELETE_SOLAR_SITE_OPTION,
  EDIT_SOLAR_SITE_OPTION,
  RECEIVE_SOLAR_SITE_OPTIONS,
  REQUEST_SOLAR_SITE_OPTION,
  REQUEST_SOLAR_SITE_OPTION_FOR_SITE,
} from '@sophocles/entities/SolarSiteOption/solarSiteOptionActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_SOLAR_SITE_OPTIONS: // Read
      return state.merge(action.solarSiteOptions);
    case DELETE_SOLAR_SITE_OPTION: // Delete
      return state.delete(action.solarSiteOption.toString());
    case EDIT_SOLAR_SITE_OPTION: // Update
    case CREATE_SOLAR_SITE_OPTION: // Create
    case REQUEST_SOLAR_SITE_OPTION:
    case REQUEST_SOLAR_SITE_OPTION_FOR_SITE:
    default:
      return state;
  }
}

export function solarSiteOptionReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_SOLAR_SITE_OPTION:
    case DELETE_SOLAR_SITE_OPTION:
    case RECEIVE_SOLAR_SITE_OPTIONS:
    case EDIT_SOLAR_SITE_OPTION:
    case REQUEST_SOLAR_SITE_OPTION:
    case REQUEST_SOLAR_SITE_OPTION_FOR_SITE:
      return getState(state, action);
    default:
      return state;
  }
}
